import * as React from "react";
import { ChevronDown } from "lucide-react";
import { cn } from "@/lib/utils";

/** A plain native <select>, not a Radix primitive — this app has no picker complex enough
 *  yet to need one, and native gives free keyboard/touch behavior on a phone for nothing. */
export function Select({ className, children, ...props }: React.ComponentProps<"select">) {
  return (
    <div className="relative">
      <select
        className={cn(
          "flex h-11 w-full appearance-none rounded-md border border-input bg-transparent px-3 py-2 pr-9 text-base " +
            "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring " +
            "disabled:cursor-not-allowed disabled:opacity-50",
          className,
        )}
        {...props}
      >
        {children}
      </select>
      <ChevronDown className="pointer-events-none absolute right-3 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground" />
    </div>
  );
}
